import { useEffect, useState } from 'react';
import { fetchTrustedPartnerLogoUrls } from '../api/modules/trustedPartners';

type UseTrustedPartnerLogosResult = {
  logos: string[];
  loading: boolean;
  error: string | null;
};

export const useTrustedPartnerLogos = (): UseTrustedPartnerLogosResult => {
  const [logos, setLogos] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const urls = await fetchTrustedPartnerLogoUrls();
        if (!cancelled) {
          setLogos(urls);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load partner logos');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { logos, loading, error };
};
